import { Component, Injector } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'text-ssn',
  templateUrl: './text-ssn.component.html',
})
export class TextSSNComponent extends BaseFormComponent {
  fieldType: string = 'ssn';

  constructor(protected injector: Injector) {
    super(injector);

    this.questionItem = this.injector.get('questionItem');

    if (this.questionItem.showifExp && this.questionItem.showifExp.includes('EIN')) {
      this.fieldType = 'ein';
    }
  }

  ngOnInit() {
    this.updateFromModel();
  }

  updateFromModel() {}
}
